// src/components/Auth/ProtectedRoute.js
import { Box, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import Login from './Login';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, hasAnyRole } = useAuth();

  if (!user) {
    return <Login />;
  }

  if (requiredRoles.length > 0 && !hasAnyRole(requiredRoles)) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #450a0a 100%)',
          color: 'white',
          p: 4,
          textAlign: 'center'
        }}
      >
        <Typography variant="h4" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.8, mb: 3 }}>
          No tienes permisos suficientes para acceder a esta sección.
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.6 }}>
          Tu rol actual: <strong>{user.role}</strong>
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;